<template lang="pug">
#modal-selecionar-camadas
    el-dialog.modal-selecionar-camadas(
        :title='$t("mensagens.menuMapa.selecionarCamadaInspecao")',
        :visible.sync='show',
        :before-close='fechar',
        width='50%',
        append-to-body,
        destroy-on-close
    )
        el-checkbox.mb-5(
            v-model='todasCamadasSelecionadas',
            @change='selecionarTodasCamadas'
        ) {{ $t('mensagens.menuMapa.selecionarTodasCamadas') }}

        .camadas
            el-checkbox-group(
                v-model='camadasSelecionadas',
                @change='selecionarCamada'
            )
                el-checkbox(
                    v-for='camada in camadas',
                    :label='camada.codigo',
                    :key='camada.codigo'
                )
                    .texto-camada {{ $t(`mensagens.camadas.${camada.codigo}`) }}

        footer(slot='footer')
            el-button(size='mini', @click='fechar') {{ $t(`mensagens.comuns.voltar`) }}
            el-button(type='primary', size='mini', @click='inspecionar') {{ $t(`mensagens.comuns.inspecionar`) }}
</template>

<script>
import store from '@/store';
import camadasVisualizacao from '@/utils/camadasV2.js';

import i18n from '@/main';
import { CamadasService } from '@/services/CamadasService';

export default {
    name: 'ModalSelecionarCamadas',

    emits: ['fechar'],

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        camadasInspecao: {
            type: Array,
            required: true
        }
    },

    watch: {
        show: function () {
            if (this.show) this.getCamadasSelecionadasMapa();
        }
    },

    data() {
        return {
            camadas: [],
            todasCamadasSelecionadas: false,
            camadasSelecionadas: [],
            i18n: i18n
        };
    },

    async mounted() {
        var camadasPermitidasPorUsuarioState_ =
            this.camadasPermitidasPorUsuarioState();
        if (camadasPermitidasPorUsuarioState_.length > 0) {
            this.onCreateCamadasPermitidasPorUsuario(
                camadasPermitidasPorUsuarioState_,
                'STATE'
            );
        } else {
            await CamadasService.buscarCamadasUsuario()
                .then(({ data }) => {
                    this.onCreateCamadasPermitidasPorUsuario(data, 'SERVICE');
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.menuCamadas.erroBuscarCamadasUsuario'
                        )
                    });
                });
        }
    },

    methods: {
        fechar() {
            this.todasCamadasSelecionadas = false;
            this.camadasSelecionadas = [];
            this.$emit('fechar');
        },

        inspecionar() {
            this.$emit('inspecionar', this.camadasSelecionadas);
            this.fechar();
        },

        selecionarTodasCamadas(todasSelecionadas) {
            this.camadasSelecionadas = todasSelecionadas
                ? this.camadas.map(camada => camada.codigo)
                : [];
        },

        selecionarCamada(camadasSelecionadas) {
            this.todasCamadasSelecionadas =
                camadasSelecionadas.length === this.camadas.length;
        },

        getCamadasSelecionadasMapa() {
            if (this.camadasInspecao.length > 0) {
                this.camadasSelecionadas = [...this.camadasInspecao];
            } else {
                this.camadasSelecionadas = [...camadasVisualizacao]
                    .filter(camada => camada.ativo)
                    .map(camada => camada.codigo);
            }
        },

        camadasPermitidasPorUsuarioState() {
            return store.state.camadasPermitidasPorUsuarioState || [];
        },

        onCreateCamadasPermitidasPorUsuario(data, type) {
            if (data && data.length > 0) {
                let layers = [...camadasVisualizacao];
                let camadasVisualizacaoFlat = [];

                let codigosCamadas = [];

                layers.map(parent => {
                    if (parent.children) {
                        if (
                            parent.children.codigo &&
                            parent.children.inspecionar &&
                            data.includes(parent.children.codigo) &&
                            !codigosCamadas.includes(parent.children.codigo)
                        ) {
                            camadasVisualizacaoFlat.push(parent.children);
                            codigosCamadas.push(parent.children.codigo);
                        }
                        parent.children.map(child => {
                            if (
                                child.codigo &&
                                child.inspecionar &&
                                data.includes(child.codigo) &&
                                !codigosCamadas.includes(child.codigo)
                            ) {
                                camadasVisualizacaoFlat.push(child);
                                codigosCamadas.push(child.codigo);
                            }
                            if (child.children) {
                                child.children.map(subChild => {
                                    if (
                                        subChild.codigo &&
                                        subChild.inspecionar &&
                                        data.includes(subChild.codigo) &&
                                        !codigosCamadas.includes(
                                            subChild.codigo
                                        )
                                    ) {
                                        camadasVisualizacaoFlat.push(subChild);
                                        codigosCamadas.push(subChild.codigo);
                                    }
                                });
                            }
                        });
                    }
                });

                if (type !== 'STATE') {
                    store.dispatch('setCamadasPermitidasPorUsuario', data);
                }

                const removerAcentos = nome => {
                    return nome
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '');
                };

                const ordenarCamadas = (a, b) => {
                    if (removerAcentos(a.nome) < removerAcentos(b.nome)) {
                        return -1;
                    }

                    if (removerAcentos(a.nome) > removerAcentos(b.nome)) {
                        return 1;
                    }

                    return 0;
                };

                this.camadas = camadasVisualizacaoFlat.sort(ordenarCamadas);
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.menuCamadas.erroBuscarCamadasUsuario'
                    )
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.camadas {
    div {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }
    .el-checkbox {
        width: 100% !important;
        display: flex;
        .texto-camada {
            white-space: normal;
            word-wrap: break-word;
            word-break: break-word;
            width: 100%;
            display: block;
        }
    }
    .texto-camada {
        white-space: normal;
        word-wrap: break-word;
        word-break: break-word;
        width: 100%;
        display: block;
    }
}

footer {
    display: flex;
    justify-content: space-between;
}
</style>
